<div class="container d-flex flex-column justify-content-center align-items-center h-100 pt-5 px-3">
    <img src="../../../assets/ff-64.png" alt="logo" />
    <h1 class="mb-4 text-center">Welcome to FlowForma Doc Gen</h1>
    <ul class="w-100">
        <li class="mb-3">Create fully customizable templates</li>
        <li class="mb-3">Rapidly generate documents, utilizing data captured throughout your processes</li>
        <li class="mb-3">Save time spent on manually creating documents such as contracts and check sheets</li>
    </ul>
    <button (click)="getStarted()" class="btn btn-primary">Get Started</button>
</div>